import { AuthorizationReason } from './../../enum/authorization-reason.enum';

import {of as observableOf,  Observable } from 'rxjs';

import {switchMap, map, withLatestFrom, retry, exhaustMap, catchError, share} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AuthorizationAction } from './authorization.action';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { BackendService } from '../../services/backend/backend.service';
import { DefaultResponse } from '../../models/form/DefaultResponse';
import { RoutesTable } from '../../resources/routes-table.model';
import { TokenChannel } from '../../enum/token-channel.enum';
import { Store } from '@ngrx/store';
import { AppState } from '../../interfaces/app-state.interface';
import { SettingsService } from '../../services/settings/settings.service';

@Injectable()
export class AuthorizationEffects {

    /**
     * Envia token de autorização para o cliente
     */
    @Effect()
    public sendAuthorizationToken$: Observable<AuthorizationAction> = this.actions$
        .pipe(
        ofType(AuthorizationAction.requestTokenTime),
        withLatestFrom(this.store.select((store) => store.authentication)),
        exhaustMap(([action, state]) => {
            const payload = {
                type: (action.payload && action.payload.channel != undefined) ? action.payload.channel : TokenChannel.Email,
                username: (state.currentUser && state.currentUser.email) ? state.currentUser.email: state.loginAttempt.username,
                clientId: this.settingsService.getConfigurationKeyValue('ci'),
                tokenReason: action.payload.tokenReason
            };

            const captchaToken = action.payload.captchaToken || null;
            const captchaSiteKey = action.payload.captchaSiteKey || null;

            return this.backendService
                .post<DefaultResponse>(
                    RoutesTable.authentication.routes.requestTokenTime.uri,
                    payload,
                    null,
                    captchaToken,
                    captchaSiteKey
                )
                .pipe(
                map((result) => {

                    if (result.ok) {
                        return { type: AuthorizationAction.requestTokenTimeSuccess };
                    }

                    return { type: AuthorizationAction.requestTokenTimeError };

                }),
                catchError((error) => {
                    return observableOf({ type: AuthorizationAction.requestTokenTimeError })
                }),
                retry(3));
        }),
        catchError((error) => {
            return observableOf({ type: '' });
        }),
        share());

    /**
     * Envia token para alteração de celular para e-mail do cliente
     */
    @Effect()
    public sendChangePhoneToken$: Observable<AuthorizationAction> = this.actions$
        .pipe(
        ofType(AuthorizationAction.requestChangePhoneToken),
        switchMap((action: any) => {

            // Solicita envio do token por e-mail para a api
            return this.backendService
                .post<DefaultResponse>(RoutesTable.authentication.routes.changeTelephone.uri, action.payload).pipe(
                map((result: any) => {

                    // Api retornou sucesso, token enviado!
                    if (result && result.ok) {
                        return {
                            type: AuthorizationAction.requestChangePhoneTokenSucess,
                            payload: result.ok
                        };
                    }

                    // Sem sucesso, token não foi enviado
                    return {
                        type: AuthorizationAction.requestChangePhoneTokenError,
                        payload: true
                    };

                }),
                catchError((error) => {
                    return observableOf({ type: AuthorizationAction.requestTokenTimeError });
                }));
        }));

    /**
     * Solicita dados básicos do cliente através de um token
     */
    @Effect()
    public requestUserByToken$: Observable<AuthorizationAction> = this.actions$
        .pipe(
        ofType(AuthorizationAction.requestUserByToken),
        switchMap((action: any) => {

            // Solicita dados (básicos) do cliente com o token recebido
            return this.backendService
                .post<DefaultResponse>(RoutesTable.authentication.routes.getUserBasicData.uri, action.payload).pipe(
                map((result: any) => {

                    // Api retornou sucesso, dados válidos.
                    if (result && result.ok) {
                        return {
                            type: AuthorizationAction.requestUserByTokenSucess,
                            payload: result.value
                        };
                    }

                    // Sem sucesso, token não existe?
                    return {
                        type: AuthorizationAction.requestUserByTokenError,
                        payload: result.messages
                    };

                }),
                catchError((error) => {
                    return observableOf({ type: AuthorizationAction.requestUserByTokenError, payload: error });
                }));
        }));

    /**
     * Solicita um token com validade até o fim do mês para o cliente
     */
    @Effect()
    public getAuthorizationMonthlyToken$: Observable<AuthorizationAction> = this.actions$
        .pipe(
        ofType(AuthorizationAction.requestTokenMonthly),
        switchMap((action: any) => {

            // Solicita dados (básicos) do cliente com o token recebido
            return this.backendService
                .post<DefaultResponse>(
                    RoutesTable.authentication.routes.requestTokenMonthly.uri,
                    action.payload
                )
                .pipe(
                map((result: any) => {

                    // Api retornou sucesso, dados válidos.
                    if (result && result.ok) {
                        return {
                            type: AuthorizationAction.requestTokenMonthlySuccess,
                            payload: result.value
                        };
                    }

                    // Sem sucesso, token não existe?
                    return {
                        type: AuthorizationAction.requestTokenMonthlyError,
                        payload: result.messages
                    };

                }),
                catchError((error) => {
                    return observableOf({ type: AuthorizationAction.requestTokenMonthlyError, payload: error });
                }));
        }),
        share());

    constructor(
        private store: Store<AppState>,
        private actions$: Actions<AuthorizationAction>,
        private backendService: BackendService,
        private settingsService: SettingsService,
    ) { }

}
